import React from 'react';
import SvgIcon from './SvgIcon';

const GasLeak = props => (
    <SvgIcon viewBox="0 0 24 24" {...props}>
        <path
            d="M19.224 15.194a3 3 0 00-3.123-4.169 5.5 5.5 0 00-10.6 1.5 5 5 0 00.472 9.975h11a4 4 0 002.251-7.306zM10.973 19v1.5"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M8.973 20.5v-1.876a3.37 3.37 0 01-2-3.124 4 4 0 118 0 3.369 3.369 0 01-2 3.123V20.5M12.223 15a.25.25 0 01.25.25M11.973 15.25a.25.25 0 01.25-.25M12.223 15.5a.25.25 0 01-.25-.25M12.473 15.25a.25.25 0 01-.25.25M9.723 15a.25.25 0 01.25.25M9.473 15.25a.25.25 0 01.25-.25M9.723 15.5a.25.25 0 01-.25-.25M9.973 15.25a.25.25 0 01-.25.25"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        <path
            d="M21.497 15.6a4 4 0 00-.272-6.408 3 3 0 00-3.123-4.169 5.5 5.5 0 00-10.605 1.5A5 5 0 002.973 11.5"
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </SvgIcon>
);

GasLeak.displayName = 'GasLeakIcon';

export default GasLeak;
